import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, flatMap, map, filter } from 'rxjs/operators';
import { PlannerConfig } from 'src/app/pages/planner/_planner-url.config';

import { AppUser } from '../entities/authDataModel';
import { DataStoreService } from './data-store.service';
import { HttpService } from './http.service';
import { SessionStorageService } from './storage.service';
import { AlertService } from './alert.service';

@Injectable()
export class AuthService {
  private currentUserSubject = new BehaviorSubject<AppUser>({} as AppUser);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();
  currentUrl: string;
  // tslint:disable-next-line:max-line-length
  constructor(private _alertService: AlertService, private location: Location, private storage: SessionStorageService, private http: HttpService, private router: Router, private _storeService: DataStoreService) {

  }
  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  public populate(returnUrl: string = '') {

    const token = this.storage.getObj('token') as AppUser;
    if (!token) {
      this.currentUserSubject.next({} as AppUser);
      // Set auth status to false
      this.isAuthenticatedSubject.next(false);
      // Remove any potential remnants of previous auth states
      if (!returnUrl) {
        this.currentUrl = this.location.path();
        console.log(this.currentUrl);
        if (this.currentUrl === '/terms-codition') {
          this.router.navigate([this.currentUrl]);
        }
        else if(this.currentUrl.includes('/powerbi-foreman')) {
          this.router.navigate([this.currentUrl]);
        }       
        else {
          this.router.navigate(['/login']);
        }
      } else {
        this.router.navigate([returnUrl]);
      }

      // }
    } else {
      const currentUser = this.getCurrentUser();
      const projectVal = this.storage.getObj('projectval');
      if (Object.keys(currentUser).length === 0) {
        this.http.get('Account/UserProfile').subscribe((user: AppUser) => {
          this.isAuthenticatedSubject.next(true);
          user.projectUserInfo = projectVal;
          this.currentUserSubject.next(Object.assign(token, user));
          this.router.navigate([this.location.path()]);
        });
      }
    }
  }

  changPassword(modal) {
    return this.http.post(PlannerConfig.EndPoint.ChangePwd.changepwd, modal);
  }

  public login(userName: string, password: string): Observable<AppUser> {
    // tslint:disable-next-line:max-line-length
    return this.http.post('Account/Login', JSON.stringify({ userName: userName.toLowerCase(), password: password, appid: 'D1E716F4-6F8D-49D2-9D15-2DFE02E53CD0' })).pipe(
      flatMap((token: AppUser) => {
        if (token.message === 'Invalid credentials') {
          this._alertService.error('Invalid credentials/Access denied');
          return;
        } else {
          this.storage.setObj('token', token);
          this.isAuthenticatedSubject.next(true);
          return this.http.get('Account/UserProfile').pipe(
            map((user: AppUser) => {
              this.currentUserSubject.next(Object.assign(token, user));
              return token;
            })
          );
        }

      })
    );
  }

  public logout() {
    return this.http.post('Account/Logout').subscribe(
      (response) => {
        console.log(response);
        this.storage.removeItem('token');
        this.storage.removeItem('projectval');
        const currentUrl = 'login';
        this.router.navigateByUrl(currentUrl).then(() => {
          this.isAuthenticatedSubject.next(false);
          this.currentUserSubject.next({} as AppUser);
          this._storeService.clearStore();
          this.router.navigated = false;
          this.router.navigate([currentUrl], { replaceUrl: true });
          this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              location.reload();
            }
          });
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  public getCurrentUser(): AppUser {
    return this.currentUserSubject.value;
  }
  public roleBasedRoute(roleName: string) {
    this.router.navigate(['/pages/admin/admin-dashboard']);
    if (roleName === 'PLN') {
      this.router.navigate(['/pages/planner/landing']);
    } else if (roleName === 'ADM') {
      this.router.navigate(['/pages/admin/admin-dashboard']);
    } else if (roleName === 'QAQC') {
      this.router.navigate(['/pages/qa-qc/dashboard']);
    }
    else if(roleName === 'REP') {
      this.router.navigate(['/pages/report-landing']);
    }
    else if (roleName === 'SAM') {
      this.router.navigate(['/pages/super-admin/sadmin-dashboard']);
    }
    else {
      this.router.navigate(['/pages/engineer/dashboard']);
    }
  }

  getProjectList() {
    console.log('Project called')
    return this.http.get(PlannerConfig.EndPoint.ProjectSetup.Getprojects);
  }
}
